export default __webpack_public_path__ + "static/media/Hekma-Logo-New1.70d591eb.svg";